var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewDidntAttend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66699C8.35117 1.66699 6.74002 2.15573 5.36961 3.0714C3.9992 3.98708 2.9311 5.2886 2.30037 6.81131C1.66964 8.33403 1.5046 10.0096 1.82614 11.6261C2.14768 13.2426 2.94134 14.7275 4.10678 15.8929C5.27222 17.0583 6.75708 17.852 8.37359 18.1735C9.9901 18.4951 11.6656 18.33 13.1884 17.6993C14.7111 17.0686 16.0126 16.0005 16.9283 14.6301C17.8439 13.2597 18.3327 11.6485 18.3327 10.0003C18.3327 7.79019 17.4547 5.67056 15.8919 4.10776C14.3291 2.54495 12.2095 1.66699 9.99935 1.66699ZM12.4685 10.9263H7.53021C7.28464 10.9263 7.04912 10.8287 6.87548 10.6551C6.70183 10.4814 6.60429 10.2459 6.60429 10.0003C6.60429 9.75475 6.70183 9.51924 6.87548 9.34559C7.04912 9.17195 7.28464 9.0744 7.53021 9.0744H12.4685C12.7141 9.0744 12.9496 9.17195 13.1232 9.34559C13.2969 9.51924 13.3944 9.75475 13.3944 10.0003C13.3944 10.2459 13.2969 10.4814 13.1232 10.6551C12.9496 10.8287 12.7141 10.9263 12.4685 10.9263Z",
    fill: "#F08E0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewDidntAttend);
export default __webpack_public_path__ + "static/media/interview-didnt-attend.bd7c4e47d959f536208b1a257edacdad.svg";
export { ForwardRef as ReactComponent };